export default __webpack_public_path__ + "static/media/013-gas mask.4d8a5153.svg";